/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Block,
    BlockFromJSON,
    BlockFromJSONTyped,
    BlockToJSON,
    BlockListAllOf,
    BlockListAllOfFromJSON,
    BlockListAllOfFromJSONTyped,
    BlockListAllOfToJSON,
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
} from './';

/**
 * A list of consensus blocks.
 * @export
 * @interface BlockList
 */
export interface BlockList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof BlockList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof BlockList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<Block>}
     * @memberof BlockList
     */
    blocks: Array<Block>;
}

export function BlockListFromJSON(json: any): BlockList {
    return BlockListFromJSONTyped(json, false);
}

export function BlockListFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'blocks': ((json['blocks'] as Array<any>).map(BlockFromJSON)),
    };
}

export function BlockListToJSON(value?: BlockList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'blocks': ((value.blocks as Array<any>).map(BlockToJSON)),
    };
}


